var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAvatarBlock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 12,
    fill: "#19252E",
    fillOpacity: 0.72
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2203 12.8162L14.4042 16L11.2203 19.1838C10.9266 19.4776 10.9266 19.9539 11.2203 20.2477L11.7523 20.7797C12.0461 21.0734 12.5224 21.0734 12.8162 20.7797L16 17.5958L19.1838 20.7797C19.4776 21.0734 19.9539 21.0734 20.2477 20.7797L20.7797 20.2477C21.0734 19.9539 21.0734 19.4776 20.7797 19.1838L17.5958 16L20.7797 12.8162C21.0734 12.5224 21.0734 12.0461 20.7797 11.7523L20.2477 11.2203C19.9539 10.9266 19.4776 10.9266 19.1838 11.2203L16 14.4042L12.8162 11.2203C12.5224 10.9266 12.0461 10.9266 11.7523 11.2203L11.2203 11.7523C10.9266 12.0461 10.9266 12.5224 11.2203 12.8162Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAvatarBlock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar_block.1a4d4690ae67a41c81853ae0a1854fed.svg";